module.exports = new Promise((resolve, reject) => {
      // Logic for dynamic resolution in non-dev environments
      const remoteUrl = window.location.origin + '/org-master/remoteEntry.js';

      if (window['framework_org_master']) {
          return resolve({
              get: (request) => window['framework_org_master'].get(request),
              init: (arg) => {
                  try {
                      return window['framework_org_master'].init(arg);
                  } catch(e) {
                      console.log('Remote container already initialized');
                  }
              }
          });
      }

      const existingScript = document.querySelector(`script[src="${remoteUrl}"]`);
      if (existingScript) {
          existingScript.addEventListener('load', () => {
              resolve({
                  get: (request) => window['framework_org_master'].get(request),
                  init: (arg) => {
                      try {
                          return window['framework_org_master'].init(arg);
                      } catch(e) {
                          console.log('Remote container already initialized');
                      }
                  }
              });
          });
          existingScript.addEventListener('error', () => {
              console.warn('Failed to load remote: framework_org_master from ' + remoteUrl);
              reject(new Error('Failed to load remote: framework_org_master'));
          });
          return;
      }

      const script = document.createElement('script');
      script.src = remoteUrl;
      script.crossOrigin = 'anonymous';
      script.onload = () => {
          resolve({
              get: (request) => window['framework_org_master'].get(request),
              init: (arg) => {
                  try {
                      return window['framework_org_master'].init(arg);
                  } catch(e) {
                      console.log('Remote container already initialized');
                  }
              }
          });
      };
      script.onerror = () => {
          console.warn('Failed to load remote: framework_org_master from ' + remoteUrl);
          reject(new Error('Failed to load remote: framework_org_master'));
      };
      document.head.appendChild(script);
  });